/// <reference path="../../typings/browser.d.ts" />

namespace Application.Models {
    'use strict';

    export interface ITimezone {
        value: string;
        abbr: string;
        offset: number;
        isdst: boolean;
        text: string;
        utc: string[];
    }
}